import { Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root',
})
export class PrintService {
	public element: any;
	public today: any;

	constructor() {}

	public download(target, title, option, svg = 1) {
		window.print();
	}
}
